import { render, staticRenderFns } from "./InspectionStandardDialog.vue?vue&type=template&id=ca70ad58&scoped=true&"
import script from "./InspectionStandardDialog.vue?vue&type=script&lang=js&"
export * from "./InspectionStandardDialog.vue?vue&type=script&lang=js&"
import style0 from "./InspectionStandardDialog.vue?vue&type=style&index=0&id=ca70ad58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca70ad58",
  null
  
)

export default component.exports